import { render, staticRenderFns } from "./BookingDetailModal.vue?vue&type=template&id=b23229be"
import script from "./BookingDetailModal.vue?vue&type=script&lang=js"
export * from "./BookingDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports